export const catalogConfigs = {
  title: {
    default: "N.CAT Company",
    ko: "N.CAT 회사소개",
  },
  langSet: ["ko", "en"],
  pageMap: {
    default: [
      { name: "cover" },
      { name: "intro", outlets: [{ name: "1" }, { name: "2" }, { name: "3" }] },
      { name: "catalog-index" },
      { name: "company-intro" },
      { name: "company-greeting" },
      { name: "company-overview" },
      { name: "company-history", outlets: [{ name: "1" }, { name: "2" }] },
      { name: "company-organization" },
      { name: "company-competence" },
      { name: "company-partner" },
      { name: "brand-intro" },
      { name: "brand-bi" },
      { name: "brand-ncat" },
      { name: "brand-global-network" },
      { name: "brand-position", outlets: [{ name: "korea" }, { name: "total" }] },
      {
        name: "brand-competence",
        outlets: [
          { name: "product" },
          { name: "price" },
          { name: "management" },
          {
            name: "jump",
            outlets: [{ name: "1" }, { name: "2" }, { name: "3" }, { name: "4" }],
          },
        ],
      },
      { name: "brand-stability" },
      { name: "store-intro" },
      { name: "store-interior-intro" },
      { name: "store-interior", outlets: [{ name: "1" }, { name: "2" }] },
      { name: "store-one-step", outlets: [{ name: "1" }, { name: "2" }] },
      {
        name: "product",
        outlets: [
          { name: "intro" },
          { name: "jewellery" },
          { name: "hair" },
          // { name: "kids" },
          { name: "other" },
          { name: "kpop" },
        ],
      },
      { name: "last" },
    ],
    en_sbm: [
      { name: "cover" },
      { name: "intro", outlets: [{ name: "1" }, { name: "2" }, { name: "3" }] },
      { name: "catalog-index" },
      { name: "company-intro" },
      { name: "company-greeting" },
      { name: "company-overview" },
      { name: "company-history", outlets: [{ name: "1" }, { name: "2" }] },
      { name: "company-organization" },
      { name: "company-competence" },
      { name: "brand-intro" },
      { name: "brand-ncat" },
      { name: "brand-global-network" },
      { name: "brand-position", outlets: [{ name: "korea" }, { name: "total" }] },
      {
        name: "brand-competence",
        outlets: [
          { name: "product" },
          { name: "price" },
          { name: "management" },
          {
            name: "jump",
            outlets: [{ name: "1" }, { name: "2" }, { name: "4" }],
          },
        ],
      },
      { name: "brand-stability" },
      { name: "brand-one-step", outlets: [{ name: "1" }, { name: "2" }] },
      {
        name: "product",
        outlets: [
          { name: "intro" },
          { name: "jewellery" },
          { name: "hair" },
          // { name: "kids" },
          { name: "other" },
          { name: "kpop" },
        ],
      },
      { name: "store-intro" },
      { name: "store-interior-intro" },
      { name: "store-interior", outlets: [{ name: "1" }, { name: "2" }] },
      { name: "store-oms" },
      { name: "last" },
    ],
  },
  autoplay: {
    delay: 1000,
    loop: true,
  },
  width: 1920,
  height: 1080,
  breakpoint: 768,
};

const ENV = process.env;
export const IS_DEV = ENV.REACT_APP_IS_DEV;
export const ROUTER_TYPE = ENV.REACT_APP_ROUTER_TYPE;
export const BASE_NAME = ENV.REACT_APP_BASE_NAME;
export const PUBLIC_URL = ENV.PUBLIC_URL;
export const IMG_URL = `${PUBLIC_URL}/images`;
